import type { ReactElement } from 'react';
import { Select } from '../../components';
import type { FilterKey } from './filters-config';
import { FILTERS } from './filters-config';

export const Filters = ({
  className,
  value,
  onChange
}: {
  className?: string;
  value: FilterKey;
  onChange: (key: FilterKey) => void;
}): ReactElement => (
  <Select
    className={className}
    value={value}
    options={FILTERS.map((f) => ({ value: f.key, label: f.label }))}
    onChange={onChange}
  />
);
